import React, { useEffect, useRef } from "react";

import { useBroadcastEditContext } from "./BroadcastEditContainer";

import { TextInput } from "@opendate-app/setlist";
import { DeliveryDateField, RecipientsSummary } from "./DeliverySummary";
import { offsetDateFromTimeZone } from "../../../shared/timeZoneLogic";

const containerStyle = {
  background: "var(--sl-bg-primary)",
  boxShadow: "var(--sl-shadow-sm)",
  padding: 24,
  width: "100%",
};

const styles = {
  fields: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    maxWidth: 500,
  },
};

const DetailsTab = () => {
  const {
    updateBroadcast,
    scheduledSend,
    selectedSendDomain,
    subject,
    setSubject,
    preheader,
    setPreheader,
    scheduledAt,
    timeZone,
    emailSendDomain,
    setEmailSendDomain,
    previouslySent,
    fetchRecipientCount,
  } = useBroadcastEditContext();

  const isInitialRender = useRef(true);

  const debouncedUpdateBroadcast = _.debounce(() => {
    updateBroadcast({
      broadcast: {
        subject: subject,
        preheader: preheader,
        email_send_domain_attributes: {
          id: emailSendDomain.id,
          name: emailSendDomain.name,
        },
        scheduled_sends_attributes: [{
          id: scheduledSend.id,
          scheduled_at: offsetDateFromTimeZone(scheduledAt, timeZone),
        }],
      }
    });
  }, 500);

  useEffect(() => {
    fetchRecipientCount();
  }, []);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
    } else {
      debouncedUpdateBroadcast();

      return () => {
        debouncedUpdateBroadcast.cancel();
      }
    }
  }, [subject, preheader, emailSendDomain]);

  return (
    <div style={containerStyle}>
      <div style={styles.fields}>
        <DeliveryDateField />
        <TextInput
          label="From name"
          helpText="We recommend using a name that your subscribers will recognize. Like your venue name."
          disabled={previouslySent}
          value={emailSendDomain.name}
          onChange={(e) => {
            setEmailSendDomain({
              ...emailSendDomain,
              name: e.target.value
            });
          }}
        />
        <TextInput
          label="From email"
          disabled
          value={selectedSendDomain?.full_from_address || ""}
        />
        <TextInput
          label="Subject line"
          disabled={previouslySent}
          value={subject || ""}
          onChange={(e) => setSubject(e.target.value)}
        />
        <TextInput
          label="Preheader"
          disabled={previouslySent}
          value={preheader || ""}
          onChange={(e) => setPreheader(e.target.value)}
        />
        <RecipientsSummary bestPracticeText="Sending to everyone in your database can damage your sending reputation and deliverability." />
      </div>
    </div>
  )
};

export default DetailsTab;
